import {
  checkSurveyPosb,
  fetchSurveyQuestionStart,
  fetchSurveyQuestionNext,
} from '../../api/survey';
import { store } from '../../store/index';

export default {
  async CHECK_SURVEY_POSB() {
    return await checkSurveyPosb(store.state.progress);
  },

  async FETCH_SURVEY_QUESTION({ commit }, surveyAnsItmId) {
    const acmltSurveyAnsItmId = [...store.state.survey.acmltSurveyAnsItmId];

    if (surveyAnsItmId) {
      commit('SET_BEFORE_SURVEY_STATE');
      commit('ADD_ACMLT_SURVEY_ANS_ITM_ID', surveyAnsItmId);
    }

    let response;
    if (!store.state.survey.survey.data) {
      response = await fetchSurveyQuestionStart(store.state.progress);
    } else {
      response = await fetchSurveyQuestionNext(
        store.state.survey.survey.data.surveyQuesId,
        store.state.survey.acmltSurveyAnsItmId
      );
    }

    if (response.data.data.surveyQuesId) {
      commit('SET_SURVEY', response.data);
    } else {
      alert('설문이 완료되어 계획표를 생성합니다.');
      window.parent.focus();
      window.parent.postMessage(
        {
          func: 'openStudyPlanSurveyResult',
          param1: store.state.progress,
          param2: store.state.survey.acmltSurveyAnsItmId.join(',')
        },
        '*'
      );
      store.state.survey.acmltSurveyAnsItmId = acmltSurveyAnsItmId;
    }

    return response;
  },
};
